import type { FaireProductEntity } from "../../entity_types/product";

export const p_gt2rsb3wmb: FaireProductEntity = {
  token: "p_gt2rsb3wmb",
  type: "product",
  name: "LYMPHATIC LOTION | 8 oz",
  brandToken: "b_5dagse75md",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9268441314e04a059f69521d3262d2705e8553baf8af5b53f36b9ee23e1658df.png",
  galleryImageUrls: [],
  priceDollars: 29,
  description:
    "\nStimulate lymph fluid drainage to promote a healthy and strong immune and circulatory system. Keeping the lymphatic system flowing is essential for optimal health!\nFor more product information or questions on products, please join our VIP group on Facebook. ",
  tags: [],
  msrpDollars: 58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:45.165Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
